{
  "id": "rars",
  "name": "RARS",
  "kind": "simulator",
  "url": "https://github.com/TheThirdOne/rars",
  "origin": "Benjamin Landers",
  "authors": [
    "Benjamin Landers"
  ],
  "started": 2017,
  "language": "Java",
  "license": "MIT",
  "isa": "RV32IMFDN, RV64IMFDN",
  "archived": false,
  "requiresJava": true,
  "flathub": "io.github.TheThirdOne.rars",
  "officialInstall": [
    {
      "kind": "jar",
      "requirements": [
        "Java 8+"
      ],
      "commands": [
        "java -jar rars_<version>.jar"
      ],
      "link": "https://github.com/TheThirdOne/rars/releases/latest"
    },
    {
      "kind": "source",
      "requirements": [
        "JDK",
        "Git"
      ],
      "commands": [
        "git clone https://github.com/TheThirdOne/rars --recursive",
        "./build-jar.sh"
      ]
    }
  ],
  "capabilities": {
    "browser": false,
    "assembler": true,
    "stepBack": true,
    "registers": true,
    "memory": true,
    "callStack": false,
    "ecalls": true,
    "gpio": false,
    "breakpoints": true,
    "pipeline": false,
    "caches": false,
    "rv64": true
  },
  "sources": [
    {
      "label": "RARS README",
      "url": "https://github.com/TheThirdOne/rars"
    },
    {
      "label": "MARS, Missouri State University",
      "url": "https://dpetersanderson.github.io/"
    }
  ],
  "blocks": [
    {
      "k": "h",
      "text": "Overview"
    },
    {
      "k": "p",
      "text": "RARS is a RISC-V assembler and simulator written in Java. An assembler translates assembly code, the readable text form of instructions, into machine code. A simulator runs that machine code by imitating a processor. RARS puts both in one desktop window together with an editor."
    },
    {
      "k": "p",
      "text": "RARS supports the 32-bit and 64-bit base instruction sets with the M extension for multiplication and division, the F and D extensions for floating point and the N extension for user-level interrupts. It shows every pseudo-instruction next to the real instructions it becomes. A pseudo-instruction is a shorthand that the assembler expands into one or more real instructions. Programs print text and read input through system calls that match those of MARS and Spike."
    },
    {
      "k": "h",
      "text": "History"
    },
    {
      "k": "p",
      "text": "Benjamin Landers created RARS in 2017 by adapting MARS 4.5. MARS is an assembler and simulator for MIPS, an older instruction set, built by Pete Sanderson and Kenneth Vollmar at Missouri State University, and it was a standard tool in assembly courses for many years."
    },
    {
      "k": "p",
      "text": "The switch from MIPS to RISC-V dropped MIPS features such as delayed branches and added a test framework that checks RARS against the RISC-V specification. Instructions load as plugins, so a new extension can be supported by placing compiled classes in a folder."
    },
    {
      "k": "h",
      "text": "Where it is used"
    },
    {
      "k": "p",
      "text": "A course that taught MIPS with MARS can move to RISC-V with RARS and keep a familiar interface and familiar system calls. RARS ships as a single file and runs on any computer with Java 8 or newer."
    }
  ]
}
